import { Label } from "@/components/ui/label.tsx"
import { Skeleton } from "@/components/ui/skeleton.tsx"
import { numberFmt } from "@/util/numberFmt.ts"

export default function MetricDisplay({
  label,
  value,
  unit,
  loading,
  error,
  bad,
  className,
  currency,
}: {
  label: string
  value: number | string
  unit?: string
  loading?: boolean
  error?: boolean
  bad?: boolean
  className?: string
  currency?: boolean
}) {
  if (loading)
    return (
      <div className={className}>
        <Label className="text-muted-foreground font-sans">
          {label}
          {unit ? <i>({unit})</i> : ""}
        </Label>
        <div className="flex justify-between items-center mt-1">
          <Skeleton className="h-[28px] w-full" />
        </div>
      </div>
    )

  if (error || typeof value === "object")
    return (
      <div className={className}>
        <Label className="text-muted-foreground font-sans">
          {label}
          {unit ? <i>({unit})</i> : ""}
        </Label>
        <div className="flex justify-between items-center mt-1">
          <span className="font-semibold text-status-bad text-xl font-sans">Network Error</span>
        </div>
      </div>
    )

  return (
    <div className={className}>
      <Label className="text-muted-foreground font-sans">
        {label}
        {unit ? <i>({unit})</i> : ""}
      </Label>
      <div className="flex justify-between items-center mt-1 font-sans">
        <span
          className={`font-semibold text-xl  ${bad ? "text-status-bad" : "text-metric-accent"}`}
        >
          {typeof value == "number"
            ? numberFmt(value, currency)
            : typeof value == "string"
              ? value
              : "N/A"}
        </span>
      </div>
    </div>
  )
}
